import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { get } from 'lodash-es';
import Container from 'reactstrap/lib/Container';
import Row from 'reactstrap/lib/Row';
import Col from 'reactstrap/lib/Col';
import { bindToPath, connectToModel } from 'client/data/luckdragon/redux/react-binding';
import { CmsEntities, CmsModel } from 'client/data/models/cms';
import { TrackingHandler } from 'client/tracking/handler';
import { CommonMap } from 'client/tracking/maps/common';
import { parseContent } from 'client/data/cms/content';
import {
  getIndustryCenterArticleBreadcrumbs,
  getIndustryCenterArticleContentPath,
} from 'site-modules/industry-center/utils/industry-center-article';
import { INDUSTRY_CENTER_ARTICLE_RIGHT_RAIL_CONTENT } from 'site-modules/industry-center/constants/industry-center-article';
import { Breadcrumbs } from 'site-modules/shared/components/breadcrumbs/breadcrumbs';
import { ContentFragment } from 'site-modules/shared/components/content-fragment/content-fragment';
import { ArticleMetadata } from 'site-modules/shared/components/editorial/article-metadata/article-metadata';
import { TypeJellybeanNavV2 } from 'site-modules/shared/components/type-jellybean-nav/type-jellybean-nav-v2';
import { ResearchSharedSubnav } from 'site-modules/shared/components/editorial/research-shared-subnav/research-shared-subnav';

import './industry-center-article.scss';

export class IndustryCenterArticleUI extends Component {
  static propTypes = {
    articleId: PropTypes.string.isRequired,
    articleCategory: PropTypes.string.isRequired,
    content: CmsEntities.Content,
    rightRailContent: CmsEntities.Content,
    isMobile: PropTypes.bool,
  };

  static defaultProps = {
    content: null,
    rightRailContent: null,
    isMobile: false,
  };

  componentDidMount() {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    TrackingHandler.useMap(CommonMap);
  }

  render() {
    const { content, rightRailContent, articleId, articleCategory, isMobile } = this.props;

    if (!content) {
      return null;
    }

    const { title, subtitle } = content;

    return (
      <Container tag="main" id="main-content" tabIndex={-1} className="industry-center-article pb-2">
        <Breadcrumbs
          className="px-0 mb-1_5"
          data={getIndustryCenterArticleBreadcrumbs({ articleCategory, articleId, title })}
        />
        <Row>
          <Col xs={12} md={8} className="pb-1 pb-md-3">
            <h1 className="heading-2">{title}</h1>
            {!!subtitle && <div className="heading-4 text-gray-darker mt-1">{subtitle}</div>}
            <ArticleMetadata className="text-gray-darker" content={content} isLegacy isMobile={isMobile} />
            <ContentFragment classes="text-gray-darker">{content.child('0').content}</ContentFragment>
          </Col>
          <Col xs={12} md={4}>
            {rightRailContent ? (
              <Fragment>
                <h2 className="heading-3 mb-1">Data Categories</h2>
                <ContentFragment classes="text-gray-darker">
                  {rightRailContent.child('specs-links').content}
                </ContentFragment>
              </Fragment>
            ) : (
              <Fragment>
                <ResearchSharedSubnav />
                <TypeJellybeanNavV2 headingClassName="heading-3" includeSymbolSheet />
              </Fragment>
            )}
          </Col>
        </Row>
      </Container>
    );
  }
}

export const mapStateToProps = state => ({
  isMobile: get(state, 'mobile'),
});
export const IndustryCenterArticle = connect(mapStateToProps)(
  connectToModel(IndustryCenterArticleUI, {
    content: bindToPath(
      ({ articleCategory, articleId }) =>
        `content["${getIndustryCenterArticleContentPath({ articleCategory, articleId })}.withContent"]`,
      CmsModel,
      parseContent
    ),
    rightRailContent: bindToPath(
      ({ articleCategory }) =>
        !!INDUSTRY_CENTER_ARTICLE_RIGHT_RAIL_CONTENT[articleCategory] &&
        `content["${INDUSTRY_CENTER_ARTICLE_RIGHT_RAIL_CONTENT[articleCategory]}.withContent"]`,
      CmsModel,
      parseContent
    ),
  })
);
